import commonEn from "@locales/en/common.json";
import evseEn from "@locales/en/evse.json";
import commonFr from "@locales/fr/common.json";
import evseFr from "@locales/fr/evse.json";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const DEFAULT_LNG = "en";
export const DEFAULT_NS = "common";
export const RESOURCES = {
	fr: {
		common: commonFr,
		evse: evseFr,
	},
	en: {
		common: commonEn,
		evse: evseEn,
	},
} as const;

const ns = Object.keys(RESOURCES[DEFAULT_LNG]);

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: RESOURCES,
		ns,
		fallbackLng: DEFAULT_LNG,
		defaultNS: DEFAULT_NS,
		interpolation: {
			escapeValue: false,
			format: (value, format, lng, options) => {
				if (format === "currency") {
					return value.toLocaleString(lng, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
						...options,
						style: "currency",
					});
				}

				return value;
			},
		},
	});

export default i18next;
